import { useState } from 'react';
import { useStripePromise } from 'views/rebranded-module/common/hooks/useStripePromise';

const useStripePaymentElement = () => {
  const [stripeData, setStripeData] = useState({
    clientKey: null,
    clientSecret: null,
    paymentIntentId: null,
    customerSessionClientSecret: null,
  });
  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const [isStripeSubmitting, setIsStripeSubmitting] = useState(false);
  const [stripeAddressValue, setStripeAddressValue] = useState(null);
  const [isStripeAddressComplete, setIsStripeAddressComplete] = useState(false);
  const stripePromise = useStripePromise(stripeData.clientKey);

  return {
    stripeData,
    setStripeData,
    stripe,
    setStripe,
    elements,
    setElements,
    isStripeSubmitting,
    setIsStripeSubmitting,
    stripeAddressValue,
    setStripeAddressValue,
    isStripeAddressComplete,
    setIsStripeAddressComplete,
    stripePromise,
  };
};

export { useStripePaymentElement };
